import TopBar from './components/TopBar';
import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import CapabilitiesSection from './components/CapabilitiesSection';
import StandardsSection from './components/StandardsSection';
import ApproachSection from './components/ApproachSection';
import ContactFooter from './components/ContactFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <TopBar />
      <main>
        <HeroSection />
        <PhilosophySection />
        <CapabilitiesSection />
        <StandardsSection />
        <ApproachSection />
      </main>
      <ContactFooter />
    </div>
  );
}